<div>
  <div style="margin-bottom: 20px;">
    <h2 style="font-size: 24px; font-weight: 700; color: #1C593D; margin: 0 0 4px 0;">Resumen de orden</h2>
    <p style="font-size: 14px; color: #666; margin: 0;">Revisa que todos los datos sean correctos</p>
  </div>

  <!-- Summary Card -->
  <div style="background: white; border-radius: 12px; padding: 20px; margin-bottom: 20px;">
    <h3 style="font-size: 18px; font-weight: 700; color: #1C593D; margin: 0 0 16px 0;">Detalle de la operacion</h3>

    <!-- Amount boxes -->
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px;">
      <div style="background: #f8f9fa; border: 2px solid #1C593D; border-radius: 12px; padding: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
        <span style="display: block; font-size: 12px; color: #666; margin-bottom: 8px; font-weight: 500;">Tu envias</span>
        <div style="font-size: 20px; font-weight: 700; color: #1a1a1a; margin-bottom: 4px;">{{ clpCurrency | currency:'':'' }}</div>
        <span style="font-size: 13px; font-weight: 600; color: #1e5a3f;">CLP</span>
      </div>
      <div style="background: #f8f9fa; border: 2px solid #1C593D; border-radius: 12px; padding: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
        <span style="display: block; font-size: 12px; color: #666; margin-bottom: 8px; font-weight: 500;">Beneficiario recibe</span>
        <div style="font-size: 20px; font-weight: 700; color: #1a1a1a; margin-bottom: 4px;">{{ vesCurrency | currency:'':'' }}</div>
        <span style="font-size: 13px; font-weight: 600; color: #1e5a3f;">VES</span>
      </div>
    </div>

    <!-- Details -->
    <div style="display: flex; flex-direction: column;">
      <div style="display: flex; align-items: center; gap: 8px; padding: 12px 0; border-bottom: 1px solid #f0f0f0;">
        <span style="font-size: 16px; flex-shrink: 0;">&#128100;</span>
        <span style="flex: 1; font-size: 14px; color: #6b7280;">Beneficiario</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f; text-align: right;">{{ beneficiario?.nombre }} {{ beneficiario?.apellidos }}</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; padding: 12px 0; border-bottom: 1px solid #f0f0f0;">
        <span style="font-size: 16px; flex-shrink: 0;">&#127974;</span>
        <span style="flex: 1; font-size: 14px; color: #6b7280;">Banco</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">{{ beneficiario?.banco?.nombre }}</span>
      </div>
      <div *ngIf="beneficiario?.banco?.codigoBanco ==='BOFA'" style="display: flex; align-items: center; gap: 8px; padding: 12px 0; border-bottom: 1px solid #f0f0f0;">
        <span style="font-size: 16px; flex-shrink: 0;">&#128290;</span>
        <span style="flex: 1; font-size: 14px; color: #6b7280;">N&deg; cuenta</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">{{ beneficiario?.numeroCuenta }}</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; padding: 12px 0;">
        <span style="font-size: 16px; flex-shrink: 0;">&#128200;</span>
        <span style="flex: 1; font-size: 14px; color: #6b7280;">Tasa CLP/VES</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">{{ ves_clp_tax }}</span>
      </div>
    </div>
  </div>

  <!-- Payment Info Card -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border: 2px solid #bbf7d0; border-radius: 12px; padding: 20px; margin-bottom: 20px;">
    <h3 style="font-size: 16px; font-weight: 700; color: #1e5a3f; margin: 0 0 12px 0;">Cuenta para pago</h3>
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 13px; color: #6b7280;">Banco</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">BCI</span>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 13px; color: #6b7280;">Razon social</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">Aguacate Investments SpA</span>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 13px; color: #6b7280;">Tipo cuenta</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">Cuenta Corriente</span>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 13px; color: #6b7280;">N&deg; Cuenta</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">46590234</span>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 13px; color: #6b7280;">RUT</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">77.258.223-4</span>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 13px; color: #6b7280;">Correo</span>
        <span style="font-size: 14px; font-weight: 600; color: #2563eb;">aguacatecambios@gmail.com</span>
      </div>
    </div>
  </div>

  <!-- File Upload -->
  <form [formGroup]="datosForm" *ngIf="datosForm" style="margin-bottom: 20px;">
    <label style="display: block; font-size: 14px; font-weight: 600; color: #1C593D; margin-bottom: 8px;">Comprobante de pago</label>

    <div class="upload-zone" style="position: relative; border: 2px dashed #bbf7d0; border-radius: 12px; padding: 16px; text-align: center; background: white; min-height: 150px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
      <!-- Preview when photo exists -->
      <ng-container *ngIf="datosForm.get('photo')!.value">
        <img [src]="datosForm.get('photo')!.value" style="max-height: 130px; max-width: 100%; border-radius: 8px;" />
        <button type="button" (click)="fileInput.value = ''; datosForm.get('photo')?.setValue(null);"
          style="position: absolute; top: 8px; right: 8px; width: 28px; height: 28px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 6px; display: flex; align-items: center; justify-content: center; cursor: pointer; z-index: 11;"
          onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="#dc2626" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </ng-container>

      <!-- Prompt when no photo -->
      <div *ngIf="!datosForm.get('photo')!.value" style="display: flex; flex-direction: column; align-items: center; gap: 8px;">
        <div style="width: 48px; height: 48px; background: #f0fdf4; border-radius: 12px; display: flex; align-items: center; justify-content: center;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 16V8M12 8L9 11M12 8L15 11M21 15V17C21 18.1 20.1 19 19 19H5C3.9 19 3 18.1 3 17V15" stroke="#1C593D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span style="font-size: 14px; font-weight: 600; color: #1C593D;">Adjuntar comprobante</span>
        <span style="font-size: 12px; color: #9ca3af;">Arrastra o haz clic para subir</span>
      </div>

      <!-- File input overlay (always present) -->
      <input #fileInput type="file" multiple="false" accept="image/*" (change)="setFileData($event)"
        style="position: absolute; z-index: 9; opacity: 0; height: 100%; width: 100%; left: 0; top: 0; cursor: pointer;" />
    </div>

    <input formControlName="photo" readonly [hidden]="true" />
  </form>

  <!-- Buttons -->
  <div style="display: flex; flex-direction: column; gap: 12px;">
    <button type="button" (click)="confirmarEnvio()"
      style="width: 100%; padding: 16px; background: #1C593D; color: white; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: background 0.2s;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      Enviar transaccion
    </button>
    <button type="button" (click)="goToBack()"
      style="width: 100%; padding: 14px; background: white; color: #374151; border: 2px solid #d1d5db; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      Volver
    </button>
  </div>
</div>
